import React from 'react';
import { SomaThemeProvider } from "@soma/ui";
import xpTheme from "@soma/themes/brands/xp/module";

export function wrapPageElement({ element }) {
  return (
    <SomaThemeProvider defaultTheme={xpTheme} defaultMode='dark' globalCssVars>
      {element}
    </SomaThemeProvider>
  );
}
